export const pxToVw = (width) => {
    return `${(width / 1920) * 100}vw`;
};
export const pxToVh = (height) => {
    return `${(height / 1080) * 100}vh`;
};
export const floorStatusByPercentage = (percentage) => {
    if (percentage < 20)
        return 'very-low';
    if (percentage < 40)
        return 'low';
    if (percentage < 60)
        return 'busy';
    if (percentage < 80)
        return 'very-busy';
    if (percentage >= 80)
        return 'crowded';
    return 'no-data';
};
function getExpiry(token) {
    const tokenPayloadBase64 = token.split('.')[1];
    let encodedString = tokenPayloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    switch (encodedString.length % 4) {
        case 0:
            break;
        case 2:
            encodedString += '==';
            break;
        case 3:
            encodedString += '=';
            break;
        default:
    }
    const decodedPayload = atob(encodedString);
    const decodedToken = JSON.parse(decodedPayload);
    return decodedToken.exp;
}
export const isExpired = (token) => {
    const expiry = getExpiry(token);
    const nowInSeconds = Date.now() / 1000;
    if (expiry < nowInSeconds) {
        const elapsed = nowInSeconds - expiry;
        console.log(`Token Expired ${elapsed.toFixed(0)} seconds ago. and now is ${nowInSeconds} and expiry is ${expiry}`);
    }
    return expiry < nowInSeconds;
};
export const expiredIn = (token, minutes) => {
    const nowMs = Date.now() / 1000;
    const cutoffMs = nowMs - minutes * 60;
    const expiry = getExpiry(token);
    return expiry < nowMs && expiry >= cutoffMs;
};
export const expiresIn = (token, minutes) => {
    const nowMs = Date.now() / 1000;
    const expiry = getExpiry(token);
    // Calculate the future cutoff:
    const cutoffMs = nowMs + minutes * 60;
    // Return true only if expiry is in the future but within x minutes:
    return expiry > nowMs && expiry <= cutoffMs;
};
export function extractTokenFromURL(url) {
    // Extract the part before the hash (#) if it exists
    const urlWithoutHash = url.split('#')[0];
    // Create a URL object for parsing the query parameters
    const urlParams = new URLSearchParams(new URL(urlWithoutHash).search);
    // Get the token from the query parameters
    return urlParams.get('token');
}
// Construct URL aptly and reload
export const loadPage = (dataService) => {
    var _a, _b, _c;
    const protocol = window.location.protocol;
    const host = window.location.host;
    const tenantMask = dataService.getTenantIdMasked();
    let redirectUrl = '';
    if (tenantMask) {
        // Configure mode: choose signage or kiosk host based on domain
        const prefix = host.endsWith('dnaspaces.io')
            ? `${protocol}//${host}`
            : `${protocol}//${host}`;
        // Build path with tenantMask
        const path = `/t/${tenantMask}`;
        const params = new URLSearchParams();
        const deviceId = (_a = dataService.getDeviceId) === null || _a === void 0 ? void 0 : _a.call(dataService);
        if (deviceId)
            params.set('deviceId', deviceId);
        const orgId = (_b = dataService.getOrgId) === null || _b === void 0 ? void 0 : _b.call(dataService);
        if (orgId)
            params.set('orgId', orgId);
        const isNav = (_c = dataService.getIsNavigator) === null || _c === void 0 ? void 0 : _c.call(dataService);
        if (isNav)
            params.set('isNav', isNav);
        const queryString = params.toString();
        redirectUrl = queryString
            ? `${prefix}${path}?${queryString}`
            : `${prefix}${path}`;
    }
    else {
        // Workspaces mode: always use workspaces host with token
        let prefix = `${protocol}//${host}`;
        if (host !== 'localhost')
            prefix = `${protocol}//workspaces.${host.split('.')[1] + '.' + host.split('.')[2]}`;
        const params = new URLSearchParams();
        params.set('token', dataService.getDeviceToken());
        redirectUrl = `${prefix}/?${params.toString()}`;
    }
    window.location.replace(redirectUrl);
};
